import { useContext } from "react";
import LocaleContext from "../app/locale/LocaleContext";

export default function () {
  return useContext(LocaleContext);
}
